import { Box, Typography } from "@compass/core";
import { Outlet } from "react-router-dom";

export const PublicLayout = () => {
  const renderCopyright = () => {
    return (
      <Box position="absolute" bottom={20} zIndex={100} >
        <Typography variant="caption">
          <>Copyright © 2006-{new Date().getFullYear()} Cobro Consulting. All Rights Reserved.</>
        </Typography>
      </Box>
    );
  };

  return (
    <Box
      display="flex"
      height="100vh"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      className="auth-layout"
      padding="50px"
    >
      <Outlet />
      {/* {renderCopyright()} */}
    </Box>
  );
};
